module.exports = __webpack_public_path__ + "img/folder.0540fe5d.svg";